<template>
  <footer class="footer">
    Copyright © {{new Date().getFullYear()}} 昆山云鲲网络科技有限公司 版权所有
    <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2022010226号</a>
    <router-link to="/about" target="_blank">关于我们</router-link>
  </footer>
</template>
<script>
export default {
    name: 'Footer',
    components: {},
    props: {

    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {

    }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>